import axiosLogInInstance from "../../../axios/login";
import axiosInstance from "../../../axios/Axios";
import {getAuthorization} from "../../../axios/AxiosAut";
import axios from "axios";
import cookie from "react-cookies";
import { baseURL } from "../../../axios/AxiosAut";

export function requestLogInUser(formData) {
  return axiosLogInInstance.post(`/users/login/`, {
    grant_type: "password",
    username: formData.username,
    password: formData.password,
    client_id: "IwXZxqdvz8puzBpu1hX5mNJlQY38hDNK8tzhu6KL",
    client_secret: "Bl83aJmhAK91vmdbPtfRF0xUVPQB2Y9rrwPzYePOgYm3qbX2Rs6GF8PV3GPOGbS1p5uVVKC9YAuysagrNsMSu2wNJWALxxTc8C0HKD4rOK4vX3ajhNNNOkP9R1hmn5Ku",
  });
}

export function requestGetCurrentUser() {
  return axios.get(`${baseURL}users/currentUser/`, {
    headers: {
      Authorization: `Bearer ${cookie.load("access_token")}`,
    },
  });
}
export function requestRegisterUser(formData) {
  return axiosLogInInstance.post(`/users/register/new/`, {
    email: formData.email,
    first_name: formData.first_name,
    last_name: formData.last_name,
  });
}
